import {
  trackConsentDeny,
  trackConsentSelected,
  trackConsentAllow,
} from '@snowplow/browser-plugin-enhanced-consent'

type EnhancedConsent = Parameters<typeof trackConsentDeny>[0]

/**
 * Track consent for snowplow based on OneTrust consent state.
 * @see https://docs.snowplow.io/docs/sources/trackers/web-trackers/tracking-events/consent-gdpr/
 * @see https://docs.snowplow.io/accelerators/consent/tracking/tracking_2/#using-onetrust
 */
export function trackConsent() {
  /*
   * Use OneTrust.GetDomainData().Groups which contains the available groups.
   * We use only groups that have cookies associated with them.
   */
  const availableGroups =
    window.OneTrust?.GetDomainData().Groups.filter(
      group => group.Cookies.length,
    ) ?? []

  const activeGroupIds =
    window.OptanonActiveGroups?.split(',').filter(Boolean) ?? []

  const consentScopes = activeGroupIds
    .map(groupId => {
      return availableGroups.find(group => groupId === group.CustomGroupId)
        ?.GroupName
    })
    .filter(s => s !== undefined)

  /*
   * Build the enhanced consent object to send to Snowplow.
   */
  const enhancedConsent: EnhancedConsent = {
    consentScopes,
    basisForProcessing: 'consent',
    consentUrl: 'https://www.giffgaff.com/boiler-plate/cookies',
    consentVersion: '1.0',
    domainsApplied: ['https://www.giffgaff.com/'],
  }

  /* Necessary cookies are always included. */
  if (consentScopes.length === 1) {
    trackConsentDeny(enhancedConsent)
  } else if (
    /* Not all scopes are consented to. */
    consentScopes.length !== availableGroups.length
  ) {
    trackConsentSelected(enhancedConsent)
  } else {
    /* All scopes are consented to. */
    trackConsentAllow(enhancedConsent)
  }
}
